import { print } from 'graphql';

import { ImageUploadDocument } from '@spotify/confidence-graphql';

import { getRegionFromTokenOrDefault } from '../behaviors/auth-factory/auth0/jwt';

export type LowercaseRegion = 'eu' | 'us';

export function deriveLowercaseRegionFromToken(token: string): LowercaseRegion {
  const region = getRegionFromTokenOrDefault(token, 'EU');
  return region === 'US' ? 'us' : 'eu';
}

export async function requestSignedUpload(
  token: string,
  region?: LowercaseRegion,
): Promise<{ signedUri: string; imageUri: string }> {
  const resolvedRegion = region ?? deriveLowercaseRegionFromToken(token);

  const query = print(ImageUploadDocument);
  const operationName = 'ImageUpload';

  const gqlResponse = await fetch(
    `https://graphql-${resolvedRegion}-konfidens.spotify.com/graphql`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ query, operationName }),
    },
  );

  if (!gqlResponse.ok) {
    throw new Error(`GraphQL request failed (${gqlResponse.status})`);
  }

  const { data } = (await gqlResponse.json()) as {
    data: { initiateImageUpload: { signedUri: string; imageUri: string } };
  };
  return data.initiateImageUpload;
}

export async function uploadFileToSignedUri(
  signedUri: string,
  file: File,
): Promise<void> {
  const uploadResponse = await fetch(signedUri, {
    method: 'PUT',
    headers: {
      'Content-Type': file.type,
      // this is a constant header that is required by the Confidence API
      // to upload images.  it's is used to limit the size of the image.
      'X-Goog-Content-Length-Range': '0,10485760',
    },
    body: file,
  });

  if (!uploadResponse.ok) {
    throw new Error('Failed to upload image');
  }
}
